<div class="titlebar">
  <h3>{{ "Template.SuppliersComponent.subHeader_suppliers" | translate }}</h3>

  <div class="buttons">
    <button class="btn btn-success" [disabled]="loading" (click)="openModal(createSupplierModal)" ngbTooltip="{{ 'Template.SuppliersComponent.tooltip_createSupplierForDataUpload' | translate }}" placement="top">
      <fa-icon icon="plus"></fa-icon>
    </button>
    <button class="btn btn-secondary" [disabled]="loading || loadingExport" (click)="exportSuppliers()" ngbTooltip="{{ 'Template.SuppliersComponent.tooltip_downloadExport' | translate }}" placement="top">
      @if (!loadingExport) {
        <fa-icon icon="cloud-download-alt"></fa-icon>
      }
      @if (loadingExport) {
        <fa-icon icon="spinner" animation="spin"></fa-icon>
      }
    </button>
  </div>
</div>

@if (loading) {
  <fa-icon icon="spinner" animation="spin"></fa-icon>
}

@if (!loading && !suppliers.length) {
  <div>
    <p>{{ "Template.SuppliersComponent.text_noSuppliersCreated" | translate }}</p>
  </div>
}

@if (!loading && suppliers.length) {
  <div>
    <table class="table table-striped">
      <caption>
        {{
        suppliers.length
        }}
        @if (suppliers.length != 1) {
          <span>{{ "Template.SuppliersComponent.text_multipleSuppliers" | translate }}</span>
        }
        @if (suppliers.length == 1) {
          <span>{{ "Template.SuppliersComponent.text_oneSupplier" | translate }}</span>
        }
      </caption>
      <thead>
        <tr>
          <th scope="col" sortable="gln" (sort)="onSort($event)">
            <fa-icon class="asc" icon="sort-up"></fa-icon>
            <fa-icon class="desc" icon="sort-down"></fa-icon>
            <fa-icon icon="sort"></fa-icon>
            {{ "Template.SuppliersComponent.text_gln" | translate }}
          </th>
          <th scope="col" sortable="name" [init]="true" (sort)="onSort($event)">
            <fa-icon class="asc" icon="sort-up"></fa-icon>
            <fa-icon class="desc" icon="sort-down"></fa-icon>
            <fa-icon icon="sort"></fa-icon>
            {{ "Template.SuppliersComponent.text_company" | translate }}
          </th>
          <th scope="col" class="text-center" sortable="partyRel.SUPPLIER_DATA_UPLOAD_RELATIONSHIP" (sort)="onSort($event)">
            <fa-icon class="asc" icon="sort-up"></fa-icon>
            <fa-icon class="desc" icon="sort-down"></fa-icon>
            <fa-icon icon="sort"></fa-icon>
            {{ "Template.SuppliersComponent.text_dataUpload" | translate }}
          </th>
          <th scope="col" class="text-center" sortable="partyRel.SUPPLIER_DATA_STREAM_RELATIONSHIP" (sort)="onSort($event)">
            <fa-icon class="asc" icon="sort-up"></fa-icon>
            <fa-icon class="desc" icon="sort-down"></fa-icon>
            <fa-icon icon="sort"></fa-icon>
            {{ "Template.SuppliersComponent.text_dataStreams" | translate }}
          </th>
          <th scope="col" class="text-center" sortable="partyRel.SUPPLIER_ORDER_RELATIONSHIP" (sort)="onSort($event)">
            <fa-icon class="asc" icon="sort-up"></fa-icon>
            <fa-icon class="desc" icon="sort-down"></fa-icon>
            <fa-icon icon="sort"></fa-icon>
            EK Online
          </th>
          <th scope="col">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        @for (supplier of suppliers; track supplier) {
          <tr>
            <td scope="row" class="align-middle">
              {{ supplier! | identification : "GLN" }}
            </td>
            <td class="align-middle">
              @if ((supplier | partyRel : 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP') && supplier.dataCatalog?.dataCatalogStatus && !(supplier.dataCatalog?.dataCatalogStatus?.status == 'READY' || supplier.dataCatalog?.dataCatalogStatus?.status == 'PRISTINE')) {
                <fa-icon icon="spinner" animation="spin" class="me-2 text-warning"></fa-icon>
              }
              {{supplier.attributes?.['NAME']}}
            </td>
            <td class="text-center align-middle">
              @if (supplier | partyRel : 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP') {
                <fa-icon icon="check" class="text-success"></fa-icon>
              }
              @if (!(supplier | partyRel : 'SUPPLIER_DATA_UPLOAD_RELATIONSHIP')) {
                <fa-icon icon="times" class="text-danger"></fa-icon>
              }
            </td>
            <td class="text-center align-middle">
              @if (supplier | partyRel : 'SUPPLIER_DATA_STREAM_RELATIONSHIP') {
                <fa-icon icon="check" class="text-success"></fa-icon>
              }
              @if (!(supplier | partyRel : 'SUPPLIER_DATA_STREAM_RELATIONSHIP')) {
                <fa-icon icon="times" class="text-danger"></fa-icon>
              }
            </td>
            <td class="text-center align-middle">
              @if (supplier | partyRel : 'SUPPLIER_ORDER_RELATIONSHIP') {
                <fa-icon icon="check" class="text-success"></fa-icon>
              }
              @if (!(supplier | partyRel : 'SUPPLIER_ORDER_RELATIONSHIP')) {
                <fa-icon icon="times" class="text-danger"></fa-icon>
              }
            </td>
            <td class="text-end align-middle">
              <a [routerLink]="['/app', 'admin', 'supplier', supplier.partyId]" class="btn btn-secondary">
                {{ "Template.SuppliersComponent.text_details" | translate }}
                <fa-icon icon="chevron-right"></fa-icon>
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

<ng-template #createSupplierModal let-modal>
  <div class="modal-header">
    @if (createStep == 1) {
      <h4 class="modal-title" id="modal-basic-title">{{ "Template.SuppliersComponent.subHeader_createSupplier" | translate }}</h4>
    }
    @if (createStep == 2) {
      <h4 class="modal-title" id="modal-basic-title">{{ "Template.SuppliersComponent.subHeader_createSupplierContact" | translate }}</h4>
    }
    <button type="button" class="btn-close" aria-label="{{ 'Common.btn_close' | translate }}" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if (createStep == 1) {
      <div>
        <form [formGroup]="supplierForm" novalidate (ngSubmit)="onSubmit($event)">
          <div class="form-group">
            <label for="gln">{{ "Template.SuppliersComponent.label_gln" | translate }}</label>
            <input type="text" class="form-control" id="gln" formControlName="gln" placeholder="{{ 'Template.SuppliersComponent.label_gln' | translate }}" />
          </div>
          <div class="form-group">
            <label for="companyName">{{ "Template.SuppliersComponent.label_companyName" | translate }}</label>
            <input type="text" class="form-control" id="companyName" formControlName="companyName" placeholder="{{ 'Template.SuppliersComponent.label_companyName' | translate }}" />
          </div>
          <div class="row">
            <div class="col-6">
              <button type="submit" class="btn btn-success d-block w-100 h-100" [disabled]="loadingCreate || !supplierForm.valid" name="{{ FINISH }}" ngbTooltip="{{ 'Template.SuppliersComponent.tooltip_create' | translate }}">
                {{ "Template.SuppliersComponent.btn_create" | translate }}
                <fa-icon icon="chevron-right"></fa-icon>
                @if (loadingCreate) {
                  <fa-icon icon="spinner" animation="spin"></fa-icon>
                }
              </button>
            </div>
            <div class="col-6">
              <button type="submit" class="btn btn-success d-block w-100 h-100" [disabled]="loadingCreate || !supplierForm.valid" name="{{ CONTINUE }}" ngbTooltip="{{ 'Template.SuppliersComponent.tooltip_createContact' | translate }}">
                {{ "Template.SuppliersComponent.btn_createContact" | translate }}
                <fa-icon icon="chevron-right"></fa-icon>
                @if (loadingContinue) {
                  <fa-icon icon="spinner" animation="spin"></fa-icon>
                }
              </button>
            </div>
          </div>
        </form>
      </div>
    }
    @if (createStep == 2 && userProps.employerPartyId) {
      <div>
        <app-create-user-form [userProps]="userProps" (exitFormEvent)="exitUserForm($event)"></app-create-user-form>
      </div>
    }

    @if (error) {
      <p class="alert alert-danger text-center mt-3">
        <strong>{{ error }}</strong>
      </p>
    }
  </div>
</ng-template>
